import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetAllArchivedProjectsRPC } from "./getAllArchivedProjectsRPC";

export class GetAllArchivedProjectsRPCClientImpl extends GetAllArchivedProjectsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetAllArchivedProjectsRPC.Request): Promise<LeoRPCResult<GetAllArchivedProjectsRPC.Response, GetAllArchivedProjectsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "project/GetAllArchivedProjects",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetAllArchivedProjectsRPC.ResponseDTO,
      GetAllArchivedProjectsRPC.Errors.ErrorsDTO,
      GetAllArchivedProjectsRPC.Response,
      GetAllArchivedProjectsRPC.Errors.Errors
    >(
      response,
      "project/GetAllArchivedProjects",
      GetAllArchivedProjectsRPC.Response.fromDTO,
      GetAllArchivedProjectsRPC.Errors.fromDTO
    );
  }
}
